/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 20th 2023, 11:39:17 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TResourceId, getPolicyRule, TAttributesFromType } from "./policies";
import { TSubject, TResource } from "./types";

interface IPolicyManager {
  canAccess(resourceId: TResourceId, subject: TSubject<any>): boolean;
}

class PolicyManager implements IPolicyManager {
  getPolicyRule<TType extends TResource["type"]>(resourceId: TResourceId) {
    return getPolicyRule<TType>(resourceId);
  }

  canAccess<TType extends TResource["type"]>(
    resourceId: TResourceId,
    subject: TSubject<TAttributesFromType<TType>>
  ): boolean {
    const rule = this.getPolicyRule<TType>(resourceId);
    const policy = rule.policy;
    return policy.checkPolicy(rule.conditions, subject);
  }
}

export const policyManager = new PolicyManager();
